import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import FileUploadField from '../../FileUploadField';

import Loading from '../../Loading';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditCertificate = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        university_name: '',
        speciality: '',
        date_end: '',
        file_id: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-certificate?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.type) {
            newErrors.type = 'Обязательное поле';
        }

        if (!formInfo.date_issue) {
            newErrors.date_issue = 'Обязательное поле';
        }

        if (action=='add' && !files.certificate) {
            newErrors.certificate = 'Обязательное поле';
        }

    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('type', formInfo.type);
        formData.append('date_issue', normalizeDate(formInfo.date_issue));

        // Добавляем файлы, если они есть
        if (files.certificate) {
        formData.append('file_certificate', files.certificate);
        }

        axios.put('/api/add-new-certificate', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            openTimeModal('Данные успешно сохранены', 'success');
            setFiles({
                certificate: null,
            });
            onSuccess();
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`}</a>);
        })
    };

    const changeData = () => {
        axios.put(`/api/change-certificate`, {
            id: formInfo.id,
            user_id: userId,
            type: formInfo.type,
            date_issue: normalizeDate(formInfo.date_issue),
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        certificate: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
          ...prev,
          [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
          ...prev,
          [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;справки
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Тип справки</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <div className='radioSwitchWrapper'>
                                    <label className={`radioSwitchLabel ${formInfo.type === 'Об отсутствии судимости' ? 'selected' : ''}`}>
                                        <input
                                            type='radio'
                                            name='typeSelector'
                                            value='Об отсутствии судимости'
                                            checked={formInfo.type === 'Об отсутствии судимости'}
                                            onChange={handleChange('type')}
                                        />
                                        <span>Об отсутствии судимости</span>
                                    </label>
                                    <label className={`radioSwitchLabel ${formInfo.type === 'Об отсутствии дисквалификации' ? 'selected' : ''}`}>
                                        <input
                                            type='radio'
                                            name='typeSelector'
                                            value='Об отсутствии дисквалификации'
                                            checked={formInfo.type === 'Об отсутствии дисквалификации'}
                                            onChange={handleChange('type')}
                                        />
                                        <span>Об отсутствии дисквалификации</span>
                                    </label>
                                </div>
                                {errorsForm.type && <div className='errorUnderInput'>{errorsForm.type}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата выдачи</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_issue?.split('T')[0]}
                                onChange={handleChange('date_issue')} 
                                className={errorsForm.date_issue ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_issue && <div className='errorUnderInput'>{errorsForm.date_issue}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Справка</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить справку'
                                        file={files.certificate}
                                        buttonLabel='Прикрепить справку'
                                        onChange={handleFileChange('certificate')}
                                        onReset={handleFileReset('certificate')}
                                    />
                                    {errorsForm.certificate && <div className='errorUnderInput'>{errorsForm.certificate}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditCertificate;